module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pg-app"
    }
  }, [(_vm.$store.getters['config/isManabi']) ? [_c('dn-db-downloader', {
    ref: "downloader",
    staticClass: "mb20",
    attrs: {
      "target": "@offers"
    },
    on: {
      "data-ready": _vm.onDataReady,
      "download": _vm.onDownload
    },
    model: {
      value: (_vm.downloadStatus),
      callback: function($$v) {
        _vm.downloadStatus = $$v
      },
      expression: "downloadStatus"
    }
  }), _vm._v(" "), (_vm.hasData) ? _c('div', [(!_vm.needFetch) ? _c('div', [(_vm.isEmpty) ? _c('div', [_vm._m(0)]) : _c('div', [_c('p', {
    staticClass: "mb15"
  }, [_vm._v("※出願の際には、各大学の最新の入試情報を確認してください。")]), _vm._v(" "), (_vm.linkReady) ? _c('ul', {
    staticClass: "my-offers"
  }, _vm._l((_vm.offers), function(offer, index) {
    return _c('li', {
      key: offer.id,
      ref: "offers",
      refInFor: true,
      staticClass: "my-offer",
      attrs: {
        "id": ("my-offer-" + (offer.id))
      }
    }, [_c('div', {
      staticClass: "my-offer__header"
    }, [_c('div', {
      staticClass: "my-offer__header-body"
    }, [_c('span', {
      staticClass: "my-offer__header-rank"
    }, [_vm._v("第" + _vm._s(index + 1) + "志望")])]), _vm._v(" "), _c('a', {
      staticClass: "my-offer__header-action",
      class: {
        'is-disabled': offer.isFirst
      },
      attrs: {
        "title": "1つ上へ移動",
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.moveOffer($event, offer, 'up')
        }
      }
    }, [_c('dn-icon', {
      class: {
        'is-disabled': offer.isFirst
      },
      attrs: {
        "icon": "tri-up"
      }
    })], 1), _vm._v(" "), _c('a', {
      staticClass: "my-offer__header-action",
      class: {
        'is-disabled': offer.isLast
      },
      attrs: {
        "title": "1つ下へ移動",
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.moveOffer($event, offer, 'down')
        }
      }
    }, [_c('dn-icon', {
      class: {
        'is-disabled': offer.isLast
      },
      attrs: {
        "icon": "tri-down"
      }
    })], 1), _vm._v(" "), _c('a', {
      staticClass: "my-offer__header-action",
      attrs: {
        "title": "削除",
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteOffer($event, offer)
        }
      }
    }, [_c('dn-icon', {
      attrs: {
        "icon": "trash"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "my-offer__body"
    }, [(offer.missing && !offer.university_name) ? _c('div', [_vm._m(1, true)]) : _c('div', [_c('h3', {
      staticClass: "my-offer__university-name"
    }, [_vm._v(_vm._s(offer.university_name))]), _vm._v(" "), _c('div', {
      staticClass: "my-offer__meta-list"
    }, _vm._l((_vm.displayItemDetailKeys), function(key) {
      return (offer[key]) ? _c('p', {
        key: key,
        staticClass: "my-offer__meta"
      }, [_vm._v(_vm._s(offer[key]))]) : _vm._e()
    })), _vm._v(" "), (offer.missing) ? _c('div', {
      staticStyle: {
        "padding-top": "10px"
      }
    }, [_vm._m(2, true)]) : _vm._e(), _vm._v(" "), _c('ul', {
      staticClass: "my-offer__links"
    }, [_c('li', {
      staticClass: "my-offer__link"
    }, [_c('dn-icon', {
      attrs: {
        "icon": "anchor"
      }
    }), _vm._v(" "), _c('a', {
      directives: [{
        name: "linkset",
        rawName: "v-linkset",
        value: ('C36'),
        expression: "'C36'"
      }],
      attrs: {
        "href": "../../jikosaiten/hantei/index.html"
      }
    }, [_vm._v("判定" + _vm._s(_vm.$store.getters['config/isManabi'] ? 'を見る' : 'チェッカーで出願校を考える'))]), _vm._v(" "), _c('dn-icon', {
      attrs: {
        "icon": "inspiration"
      }
    })], 1), _vm._v(" "), _c('li', {
      staticClass: "my-offer__link"
    }, [_c('dn-icon', {
      attrs: {
        "icon": "link"
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "gaibu-link",
      attrs: {
        "href": ("https://manabi.benesse.ne.jp/daigaku/school/" + (offer.university_id) + "/nyushi/index.html"),
        "target": "_blank"
      }
    }, [_vm._v("最新の入試情報を見る")])], 1), _vm._v(" "), _c('li', {
      staticClass: "my-offer__link"
    }, [_c('dn-icon', {
      attrs: {
        "icon": "link"
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "gaibu-link",
      attrs: {
        "href": ("https://manabi.benesse.ne.jp/daigaku/school/" + (offer.university_id) + "/index.html"),
        "target": "_blank"
      }
    }, [_vm._v("パンフ・願書を取り寄せる")])], 1), _vm._v(" "), (!_vm.$store.getters['config/isManabi']) ? _c('li', {
      staticClass: "my-offer__link"
    }, [_c('dn-icon', {
      attrs: {
        "icon": "anchor"
      }
    }), _vm._v(" "), _c('a', {
      directives: [{
        name: "linkset",
        rawName: "v-linkset",
        value: ('C19'),
        expression: "'C19'"
      }],
      attrs: {
        "href": "../../refresh/i_sum.html",
        "target": "_blank"
      }
    }, [_vm._v("インターネット選太君で出願校を考える")]), _vm._v(" "), _c('dn-icon', {
      attrs: {
        "icon": "inspiration"
      }
    })], 1) : _vm._e()])])])])
  })) : _vm._e(), _vm._v(" "), (_vm.offers.length >= 1) ? _c('div', {
    staticClass: "my-to-checker tar mt30"
  }, [_c('dn-btn', {
    staticClass: "my-to-checker__btn",
    attrs: {
      "accent": "",
      "href": "../../jikosaiten/hantei/index.html",
      "linkset": "C36"
    }
  }, [_vm._v("\n            判定の確認" + _vm._s(_vm.$store.getters['config/isManabi'] ? '' : '　判定チェッカー') + "\n          ")])], 1) : _vm._e()])]) : _vm._e()]) : _vm._e()] : [_c('dn-db-downloader', {
    ref: "downloader",
    staticClass: "mb20",
    attrs: {
      "target": "@offers"
    },
    on: {
      "data-ready": _vm.onDataReady,
      "download": _vm.onDownload
    },
    model: {
      value: (_vm.downloadStatus),
      callback: function($$v) {
        _vm.downloadStatus = $$v
      },
      expression: "downloadStatus"
    }
  }), _vm._v(" "), (_vm.hasData) ? _c('div', [(!_vm.needFetch) ? _c('div', [(_vm.isEmpty) ? _c('div', [_vm._m(3)]) : _c('div', [_c('p', {
    staticClass: "mb15"
  }, [_vm._v("※出願の際には、各大学の最新の入試情報を確認してください。")]), _vm._v(" "), (_vm.linkReady) ? _c('ul', {
    staticClass: "my-offers"
  }, _vm._l((_vm.offers), function(offer, index) {
    return _c('li', {
      key: offer.id,
      ref: "offers",
      refInFor: true,
      staticClass: "my-offer",
      attrs: {
        "id": ("my-offer-" + (offer.id))
      }
    }, [_c('div', {
      staticClass: "my-offer__header"
    }, [_c('div', {
      staticClass: "my-offer__header-body"
    }, [_c('span', {
      staticClass: "my-offer__header-rank"
    }, [_vm._v("第" + _vm._s(index + 1) + "志望")])]), _vm._v(" "), _c('a', {
      staticClass: "my-offer__header-action",
      class: {
        'is-disabled': offer.isFirst
      },
      attrs: {
        "title": "1つ上へ移動",
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.moveOffer($event, offer, 'up')
        }
      }
    }, [_c('dn-icon', {
      class: {
        'is-disabled': offer.isFirst
      },
      attrs: {
        "icon": "tri-up"
      }
    })], 1), _vm._v(" "), _c('a', {
      staticClass: "my-offer__header-action",
      class: {
        'is-disabled': offer.isLast
      },
      attrs: {
        "title": "1つ下へ移動",
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.moveOffer($event, offer, 'down')
        }
      }
    }, [_c('dn-icon', {
      class: {
        'is-disabled': offer.isLast
      },
      attrs: {
        "icon": "tri-down"
      }
    })], 1), _vm._v(" "), _c('a', {
      staticClass: "my-offer__header-action",
      attrs: {
        "title": "削除",
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteOffer($event, offer)
        }
      }
    }, [_c('dn-icon', {
      attrs: {
        "icon": "trash"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "my-offer__body"
    }, [(offer.missing && !offer.university_name) ? _c('div', [_vm._m(4, true)]) : _c('div', [_c('h3', {
      staticClass: "my-offer__university-name"
    }, [_vm._v(_vm._s(offer.university_name))]), _vm._v(" "), _c('div', {
      staticClass: "my-offer__meta-list"
    }, _vm._l((_vm.displayItemDetailKeys), function(key) {
      return (offer[key]) ? _c('p', {
        key: key,
        staticClass: "my-offer__meta"
      }, [_vm._v(_vm._s(offer[key]))]) : _vm._e()
    })), _vm._v(" "), (offer.missing) ? _c('div', {
      staticStyle: {
        "padding-top": "10px"
      }
    }, [_vm._m(5, true)]) : _vm._e(), _vm._v(" "), _c('ul', {
      staticClass: "my-offer__links"
    }, [_c('li', {
      staticClass: "my-offer__link"
    }, [_c('dn-icon', {
      attrs: {
        "icon": "anchor"
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": ("https://manabi.benesse.ne.jp/daigaku/school/" + (offer.university_id) + "/index.html"),
        "target": "_blank"
      }
    }, [_vm._v("パンフ・願書を取り寄せる")])], 1), _vm._v(" "), _c('li', {
      staticClass: "my-offer__link"
    }, [_c('dn-icon', {
      attrs: {
        "icon": "anchor"
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": ("https://manabi.benesse.ne.jp/daigaku/school/" + (offer.university_id) + "/nyushi/index.html"),
        "target": "_blank"
      }
    }, [_vm._v("最新の入試情報を見る")])], 1), _vm._v(" "), _c('li', {
      staticClass: "my-offer__link"
    }, [_c('dn-icon', {
      attrs: {
        "icon": "anchor"
      }
    }), _vm._v(" "), _c('a', {
      directives: [{
        name: "linkset",
        rawName: "v-linkset",
        value: ('B3'),
        expression: "'B3'"
      }],
      attrs: {
        "href": "../../bible/exam/index.html"
      }
    }, [_vm._v("過去の共通テスト・センター試験を解いて強化する科目・分野を把握する")]), _vm._v(" "), _c('dn-icon', {
      attrs: {
        "icon": "inspiration"
      }
    })], 1), _vm._v(" "), _c('li', {
      staticClass: "my-offer__link"
    }, [_c('dn-icon', {
      attrs: {
        "icon": "anchor"
      }
    }), _vm._v(" "), _c('a', {
      directives: [{
        name: "linkset",
        rawName: "v-linkset",
        value: ('C36'),
        expression: "'C36'"
      }],
      attrs: {
        "href": ("../../jikosaiten/hantei/index.html?offer=" + (index + 1)),
        "target": "_blank"
      }
    }, [_vm._v("判定" + _vm._s(_vm.$store.getters['config/isManabi'] ? 'を見て' : 'チェッカーで') + "出願校を考える")]), _vm._v(" "), _c('dn-icon', {
      attrs: {
        "icon": "inspiration"
      }
    })], 1), _vm._v(" "), (!_vm.$store.getters['config/isManabi']) ? _c('li', {
      staticClass: "my-offer__link"
    }, [_c('dn-icon', {
      attrs: {
        "icon": "anchor"
      }
    }), _vm._v(" "), _c('a', {
      directives: [{
        name: "linkset",
        rawName: "v-linkset",
        value: ('C19'),
        expression: "'C19'"
      }],
      attrs: {
        "href": "../../refresh/i_sum.html",
        "target": "_blank"
      }
    }, [_vm._v("インターネット選太君で出願校を考える")]), _vm._v(" "), _c('dn-icon', {
      attrs: {
        "icon": "inspiration"
      }
    })], 1) : _vm._e()])])])])
  })) : _vm._e(), _vm._v(" "), (_vm.offers.length >= 3) ? _c('div', {
    staticClass: "tar mt30"
  }, [(_vm.$store.getters['config/isManabi']) ? _c("dn-btn", {
    tag: "a",
    staticClass: "pg-linkto-search dn-btn--plain dn-btn--block-sp",
    on: {
      "click": function($event) {
        _vm.storeUnivList()
      }
    }
  }, [_vm._v("DB連携")]) : _vm._e(), _vm._v(" "), _c("dn-btn", {
    tag: "a",
    staticClass: "pg-linkto-search dn-btn--plain dn-btn--block-sp",
    attrs: {
      "linkset": "B6",
      "href": "../search/index.html"
    }
  }, [_vm._v("大学検索")])]) : _vm._e()])]) : _vm._e()]) : _vm._e()]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin-bottom": "120px"
    }
  }, [_vm._v("現在登録はありません。「"), _c('a', {
    attrs: {
      "href": "../search/index.html"
    }
  }, [_vm._v("志望校を検索・登録する")]), _vm._v("」からご登録ください。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "my-offer__missing-notice"
  }, [_vm._v("募集単位に改組がありました。"), _c('wbr'), _vm._v("選択し直してください。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "my-offer__missing-notice"
  }, [_vm._v("大学入学共通テストを利用しない募集単位のため、判定できません。志望校の登録を再度ご確認ください。"), _c('br'), _vm._v("（国公立大学以外で大学入学共通テストを利用する場合は募集単位名に「共テ」がついています）")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin-bottom": "120px"
    }
  }, [_vm._v("現在登録はありません。「"), _c('a', {
    attrs: {
      "href": "../search/index.html"
    }
  }, [_vm._v("志望大学を検索・登録する")]), _vm._v("」からご登録ください。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "my-offer__missing-notice"
  }, [_vm._v("募集単位に改組がありました。"), _c('wbr'), _vm._v("選択し直してください。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "my-offer__missing-notice"
  }, [_vm._v("大学入学共通テストを利用しない募集単位のため、判定できません。志望校の登録を再度ご確認ください。"), _c('br'), _vm._v("（国公立大学以外で大学入学共通テストを利用する場合は募集単位名に「共テ」がついています）")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2de2106","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/bible/myuniv/App.vue
// module id = 847
// module chunks = 11